import { Link } from "react-router-dom";

export function EmptyContainer() {
    return (
        <div className="flex justify-center items-center border-2 p-2 rounded-md shadow-sm h-[400px] flex-col gap-2">
            <h4 className="text-2xl font-bold">No sections to display</h4>
            <p className="text-gray-500">Please select some sections in the settings</p>
            <Link to="/settings" className="text-blue-500 hover:underline">Go to settings</Link>
        </div>
    )
}